// src/components/sections/MissionStatement.js

import React from 'react';

const MissionStatement = () => {
  return (
    <section className="relative bg-soft-earth shadow-md px-6 pt-8 pb-16 md:px-20 text-deep-navy border-l-8 border-r-8 border-primary">
      <div className="absolute top-0 left-0 w-full h-[4px] bg-warm-orange z-10" />

      <div className="max-w-4xl mx-auto">
        {/* Mission Heading Image */}
        <div className="text-center mb-10 mt-0">
          <img
            src="/images/OurMission2.svg"
            alt="Our Mission"
            className="w-2/3 sm:w-1/2 lg:w-[500px] mx-auto mb-4 mt-0 leading-none"
          />
        </div>

        <div className="space-y-6 text-base md:text-xl leading-[1.75] font-normal text-gray-900">
          <p>
            At Better Turns, we believe{' '}
            <strong className="font-semibold text-primary">
              small retailers are the backbone of strong communities
            </strong>
            —and they deserve better.
          </p>

          <p>
            For too long, the retail landscape has been dominated by{' '}
            <span className="text-warm-orange font-semibold">
              mega-corporations
            </span>
            , global supply chains, and financial systems designed to favor the
            few. These forces have drained local wealth and shuttered family-run
            businesses in towns across America.
          </p>

          <p>
            <strong className="text-rosewood font-bold text-xl md:text-2xl">
              We say: it's time to change the game!
            </strong>
          </p>

          <p>
            The Better Turns Movement is a grassroots revolution. It’s about{' '}
            <strong className="text-emerald-green">
              returning economic power to local business owners
            </strong>{' '}
            and creating a future where small stores can compete fairly, serve
            their communities better, and retain more of the value they create.
          </p>

          <p>
            We provide tools and technologies once reserved for big-box
            retailers—
            <span className="font-semibold text-deep-navy">
              advanced analytics, shared buying power, vendor-supported
              inventory models, and cloud-native ERP and POS systems
            </span>
            —all tailored for independent businesses.
          </p>

          <p>
            But Better Turns is more than software. It’s a{' '}
            <span className="text-primary font-semibold">
              co-operative platform
            </span>{' '}
            built on trust, data sharing, and mutual success. It’s about giving
            retailers the visibility and leverage they need to make informed
            decisions, negotiate better deals, and grow sustainably.
          </p>

          <p>
            We’re here to <strong>restore dignity to local ownership</strong>,
            create opportunity for the next generation, and help communities
            prosper from the inside out.
          </p>

          <p>
            <strong className="italic">
              This isn’t about squeezing more profit—it’s about unlocking shared
              value.
            </strong>
            <br />
            <strong className="italic">
              This isn’t about playing by the old rules—it’s about writing new
              ones.
            </strong>
          </p>

          <p>
            <span className="font-bold text-primary">
              Together, we will revitalize Main Street, strengthen neighborhood
              economies, and deliver Better Turns for all.
            </span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default MissionStatement;
